import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import * as React from "react";
import LazyImage from '../general/lazyImage';
import Translate from '../general/translate';

const Agenciessection = () => {
   return (
    <div className="pt-14 pb-10 bg-[#27004F]" id="contentsection">
        <div className="bg-[#27004F] px-6 mb-14 md:mb-24">
            <div className="max-w-7xl m-auto flex flex-col lg:flex-row items-center lg:items-center mb-14 gap-x-4">
                <div className="lg:w-2/5 mb-10 lg:mb-0 text-white">
                    <h2 className="text-2xl lg:text-3xl font-bold">
                        <Translate id="agenciessection.joinCreators" foldername="home" filename="home-agenciessection" />
                    </h2>
                </div>
                <div className="lg:w-3/5 flex flex-nowrap justify-center lg:justify-start gap-2 overflow-x-auto items-center">
                    <div className="relative w-[calc(33.33%-8px)] flex-shrink-0">
                        <LazyImage src="/home/content-creators.webp" className="rounded-lg w-full" alt="Podcasters" />
                        <div className="absolute bottom-0 left-0 bg-[#27004F] bg-opacity-50 text-white p-2 rounded-bl-lg rounded-tr-lg text-semibold">
                            <Translate id="agenciessection.contentCreators" foldername="home" filename="home-agenciessection" />
                        </div>
                    </div>
                    <div className="relative w-[calc(33.33%-8px)] flex-shrink-0">
                        <LazyImage src="/home/podcast-managers.webp" className="rounded-lg w-full" alt="Video creators" />
                        <div className="absolute bottom-0 left-0 bg-[#27004F] bg-opacity-50 text-white p-2 rounded-bl-lg rounded-tr-lg text-semibold">
                            <Translate id="agenciessection.podcastManagers" foldername="home" filename="home-agenciessection" />
                        </div>
                    </div>
                    <div className="relative w-[calc(33.33%-8px)] flex-shrink-0">
                        <LazyImage src="/home/podcast-studios.webp" className="rounded-lg w-full" alt="Producers" />
                        <div className="absolute bottom-0 left-0 bg-[#27004F] bg-opacity-50 text-white p-2 rounded-bl-lg rounded-tr-lg text-semibold">
                            <Translate id="agenciessection.producersStudios" foldername="home" filename="home-agenciessection" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="w-5/6 m-auto mb-10">
            <h3 className="text-center text-md leading-tight font-extrabold text-white opacity-60 tracking-wide mb-8">
                <Translate id="agenciessection.forPodcasters" foldername="home" filename="home-agenciessection" />
            </h3>
            <h2 className="text-center leading-tight text-3xl lg:text-5xl text-[#F3F3F1] font-bold mb-10">
                <Translate id="agenciessection.manageContent" foldername="home" filename="home-agenciessection" />
                <span className="text-[#FFCA1D] font-extrabold"> <Translate id="agenciessection.multiplePodcasts" foldername="home" filename="home-agenciessection" /></span>
            </h2>
            <p className="text-xl mb-5 text-center text-[#B8AEC3] lg:px-20">
                <Translate id="agenciessection.podsqueezeDescription" foldername="home" filename="home-agenciessection" />
            </p>
            <p className="text-xl text-center text-[#B8AEC3] py-2">
                <FontAwesomeIcon icon={faCheck} className={"text-[#3ADAD9] text-xl mr-3"} />
                <Translate id="agenciessection.createPodcastFolders" foldername="home" filename="home-agenciessection" />
            </p>
            <p className="text-xl text-center text-[#B8AEC3] py-2">
                <FontAwesomeIcon icon={faCheck} className={"text-[#3ADAD9] text-xl mr-3"} />
                <Translate id="agenciessection.shareContent" foldername="home" filename="home-agenciessection" />
            </p>
            <p className="text-xl text-center text-[#B8AEC3] py-2">
                <FontAwesomeIcon icon={faCheck} className={"text-[#3ADAD9] text-xl mr-3"} />
                <Translate id="agenciessection.tuneAI" foldername="home" filename="home-agenciessection" />
            </p>
            <p className="text-xl text-center text-[#B8AEC3] py-2">
                <FontAwesomeIcon icon={faCheck} className={"text-[#3ADAD9] text-xl mr-3"} />
                <Translate id="agenciessection.planContent" foldername="home" filename="home-agenciessection" />
                <a href="/podcast-topics-ideas/" className="font-bold text-[#FFCA1D]">
                    <Translate id="agenciessection.podcastTopicsFinder" foldername="home" filename="home-agenciessection" />
                </a>
            </p>
        </div>
        <div className="w-5/6 md:w-1/2 lg:w-5/6 lg:px-14 m-auto mt-20">
            <div className="flex justify-center items-center h-full">
                <LazyImage src="/home/tunegraphics.webp" alt="Podsqueeze AI prompt feature" className="w-auto lg:px-10" />
            </div>
        </div>
        <div className="max-w-2xl w-5/6 sm:w-3/4 m-auto mb-10 mt-12 text-center">
            <div className="flex flex-col sm:flex-row items-center justify-center">
                <LazyImage src="/home/celinepodigy.webp" className="h-32 w-32 rounded-full cursor-pointer mt-5 mb-5 sm:mt-0 sm:mb-0 sm:mr-5" alt="Justin Jackson Co-founder of transistor" />
                <div className="text-left">
                    <FontAwesomeIcon icon={faQuoteLeft} className="text-[#B8AEC3] text-2xl" />
                    <p className="text-[#B8AEC3] mb-4 text-md items-center italic semibold">
                        <Translate id="agenciessection.podsqueezeQuote" foldername="home" filename="home-agenciessection" />
                    </p>
                    <p className="text-[#B8AEC3] text-lg font-bold">Celine Albertini</p>
                    <a href="https://podigypodcasts.com/" className="text-[#B8AEC3]" target="_blank" rel="noopener noreferrer">
                        <Translate id="agenciessection.coO" foldername="home" filename="home-agenciessection" />
                    </a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Agenciessection;